<template>
  <el-dialog
    :title="$t('common.deleteConfirm')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <p>{{ $t('resourceStoreType.deleteConfirmText') }}</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteResourceStoreType } from '@/api/housekeeping/resourceStoreTypeApi'

export default {
  name: 'DeleteResourceStoreType',
  data() {
    return {
      dialogVisible: false,
      currentRow: null
    }
  },
  methods: {
    open(row) {
      this.currentRow = row
      this.dialogVisible = true
    },
    async handleConfirm() {
      try {
        await deleteResourceStoreType({ rstId: this.currentRow.rstId })
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error('删除失败:', error)
      }
    }
  }
}
</script>